import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Loader from '../shared/Loader';
import { getText, trackGA } from 'misc/helpers';
import * as types from 'misc/types';

class Verifications extends Component {
    constructor(props) {
        super(props);

        props.dispatch({ type: types.SAGA_VERIFICATIONS.REQUEST, token: props.match.params.token });
    }

    render = () => {
        const { verifications } = this.props;

        return (
            <div className="main-content">
                <div className="complement-content">
                    <Loader objectToLoad={verifications}>
                        {verifications.isLoaded && (
                            <React.Fragment>
                                <img src="assets/images/popup/ico_success.svg" alt="" />
                                <br />
                                <h1>{getText('_verify_email_page_titel', 'E-post verifierad')}</h1>
                                <p>
                                    {getText(
                                        '_verify_email_page_text',
                                        'Din e-post är nu verifierad. Du kan nu gå till Digimail för att läsa din post.'
                                    )}
                                </p>
                                <Link to={'/'}>
                                    <button className="button-yellow button-big button-bankid">
                                        {getText('_verify_email_page_button', 'Till Digimail')}
                                    </button>
                                </Link>
                            </React.Fragment>
                        )}
                    </Loader>
                </div>

                <img className="logo-bottom-left" src="assets/images/digimail_logo_yellow.svg" alt="" />
            </div>
        );
    };

    componentDidMount() {
        trackGA('1.4 Verifiera epost');
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        verifications: state.verifications
    };
};

export default connect(mapStateToProps)(Verifications);



// WEBPACK FOOTER //
// ./src/components/views/Verifications.js